parseTokenWww